<template>
  <div class="comics">
    <span v-if="checkDevice=='mobile'" class="title">ブルーアーカイブ<br><span class="subtitle">公式4コマ</span></span>
    <div class="center">
      <img v-if="checkDevice=='pc'" class="titleQImg" src="@/assets/images/comics/titleQ.png" alt="">
      <img v-else class="titleQImg" src="@/assets/images/comics/titleQm.png" alt="">
      <img class="titleImg" src="@/assets/images/comics/title.png" alt="">
      <div class="content">
        <div v-for="(item, index) in comicList" :key="index" class="comic" @click="openPopup(item)">
          <div class="imgBox">
            <div v-if="item.new" class="shadow"></div>
            <img v-if="item.new" class="new" src="@/assets/images/comics/new.png" alt="">
            <div class="coverBox">
              <img class="cover" :src="item.thumbnail" alt="">
            </div>
          </div>
          <span class="comicTitle">{{item.title}}</span>
        </div>
      </div>
      <div v-if="navlistLength<=3" class="navBox">
        <div class="comicNum" v-for="(item, index) in navlist" :class="index==comics.pageIndex-1?'active':''" :key="index" @click="changeComicNum(index)">
          {{item[0]}}{{item[1]?'-':''}}{{item[1]}}
        </div>
      </div>
      <div v-else class="navBox">
        <div v-if="prevshow" class="prev1 navButton" @click="prev2">I&lt;</div>
        <div v-if="prevshow" class="prev2 navButton" @click="prev1">&lt;</div>
        <div class="comicNum" v-show="showNav(index)" v-for="(item, index) in navlist" :class="index==comics.pageIndex-1?'active':''" :key="index" @click="changeComicNum(index)">
          {{item[0]}}{{item[1]&&item[0]!=item[1]?'-':''}}{{item[0]!=item[1]?item[1]:''}}
        </div>
        <div v-if="nextshow" class="next1 navButton" @click="next1">&gt;</div>
        <div v-if="nextshow" class="next2 navButton" @click="next2">&gt;I</div>
      </div>
    </div>
    <div class="popup" v-if="popup">
      <div class="popup_center">
        <img class="close" src="@/assets/images/comics/close.png" alt="" @click="closePopup">
        <img class="mainImg" :src="comicPopup.comic" alt="">
        <div class="popup_navBox">
          <div v-show="comicsPopup.chapters!=1" class="popup_navBox-prev popup_navBox-navButton" @click="popup_prev">&lt;</div>
          <div class="popup_comicNum">{{comicPopup.title}}</div>
          <div v-show="comicsPopup.chapters!=pageCountNum" class="popup_navBox-next popup_navBox-navButton" @click="popup_next">&gt;</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'comics',
  data: () => ({
    popup: false,
    pageCountNum: 0,
    comicList: [],
    comics: {
      pageNum: 12,
      pageIndex: 1,
      type: 1,
    },
    comicsPopup: {
      chapters: 1,
      type: 1,
    },
    comicPopup: {}
  }),
  computed: {
    checkDevice() {
      return this.$utils.checkDevice();
    },
    navlist() {
      let navlist = []
      if(this.pageCountNum==0) {
      } else if(this.pageCountNum==1) {
        navlist.push([1])
      } else if(this.pageCountNum<=12) {
        navlist.push([1, this.pageCountNum])
      } else {
        for(let i=this.pageCountNum; 0<i; i-=12) {
          if(i>12) {
            navlist.push([i, i-11])
          } else {
            navlist.push([i, 1])
          }
        }
      }
      return navlist
    },
    navlistLength() {
      return this.navlist.length
    },
    prevshow() {
      return this.comics.pageIndex!=1?true:false
    },
    nextshow() {
      return this.comics.pageIndex!=this.navlistLength&&this.comics.pageIndex!=this.navlistLength?true:false
    }
  },
  methods: {
    prev1() {
      this.comics.pageIndex-=1
      this.comicInit()
    },
    prev2() {
      this.comics.pageIndex=1
      this.comicInit()
    },
    next1() {
      this.comics.pageIndex+=1
      this.comicInit()
    },
    next2() {
      this.comics.pageIndex=this.navlistLength
      this.comicInit()
    },
    popup_prev() {
      this.comicsPopup.chapters-=1
      this.$router.push({
        path: `/comics/${this.comicsPopup.chapters}/${this.comicsPopup.type}`,
      })
      this.comicPopupInit()
    },
    popup_next() {
      this.comicsPopup.chapters+=1
      this.$router.push({
        path: `/comics/${this.comicsPopup.chapters}/${this.comicsPopup.type}`,
      })
      this.comicPopupInit()
    },
    closePopup() {
      this.popup = false
      this.$router.push({
        path: `/comics`,
      })
    },
    openPopup(item) {
      this.comicsPopup.chapters = item.chapters
      this.$router.push({
        path: `/comics/${this.comicsPopup.chapters}/${this.comicsPopup.type}`,
      })
      this.comicPopupInit()
      this.popup = true
    },
    changeComicNum(index) {
      this.comics.pageIndex=index+1
      this.comicInit()
    },
    comicInit() {
      this.axios.get(`/cms/comic/list?pageIndex=${this.comics.pageIndex}&pageNum=${this.comics.pageNum}&type=${this.comics.type}`)
      .then(v => {
        this.comicList = v.data.data.comicList
        this.pageCountNum = v.data.data.pageCountNum
      }).catch(e => {
        console.log(e)
      })
    },
    comicPopupInit() {
      this.axios.get(`/cms/comic/detail?chapters=${this.comicsPopup.chapters}&type=${this.comicsPopup.type}`)
      .then(v => {
        this.comicPopup = v.data.data
      }).catch(e => {
        console.log(e)
      })
    },
    showNav(index) {
      let show = false
      if(index==this.comics.pageIndex||index-1==this.comics.pageIndex||index+1==this.comics.pageIndex) {
        show = true
      } else if ((this.navlistLength-this.comics.pageIndex<=2&&this.navlistLength-index<=2)||(this.navlistLength-this.comics.pageIndex<=1&&this.navlistLength-index<=1)) {
        show = true
      }
      return show
    }
  },
  mounted() {
    this.comicInit()
    if(!Object.keys(this.$route.params).length == 0) {
      this.comicsPopup.chapters = parseInt(this.$route.params.chapters)
      this.comicPopupInit()
      this.popup = true
    }
  }
}
</script>
<style lang="scss" scoped>
.comics {
  width: 100%;
  background: url('../assets/images/comics/bg.png') no-repeat;
  background-size: cover;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  .title {
    margin-top: pxTorem(150px);
    color: #fff;
    font-family: "Noto Sans JP", sans-serif;
    font-weight: 400;
    font-size: pxTorem(36px);
    line-height: pxTorem(36px);
    text-align: center;
    letter-spacing: pxTorem(4px);
    .subtitle {
      font-size: pxTorem(24px);
    }
  }
  .center {
    margin-top: pxTorem(330px);
    position: relative;
    width: pxTorem(1070px);
    height: 20%;
    border: pxTorem(6px) solid #00ccff;
    border-radius: pxTorem(20px);
    background-color: rgb(0, 0, 0, 0.43);
    margin-bottom: pxTorem(70px);
    .titleQImg {
      position: absolute;
      width: 78%;
      top: 0;
      right: 49%;
      transform: translate(50%, -100%);
    }
    .titleImg {
      position: absolute;
      width: 49.5%;
      top: 0;
      left: 50%;
      transform: translate(-50%, -80%);
    }
    .content {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      margin-top: pxTorem(50px);
      width: auto;
      height: pxTorem(505px);
      .comic {
        width: pxTorem(220px);
        height: pxTorem(142px);
        margin: pxTorem(10px) pxTorem(10px);
        border: pxTorem(3px) solid #fff;
        border-radius: pxTorem(15px);
        overflow: hidden;
        background-color: #fff;
        position: relative;
        cursor: pointer;
        .imgBox {
          position: relative;
          .shadow {
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;
            width: pxTorem(220px);
            height: pxTorem(113px);
            background-color: rgb(0, 0, 0, 0.43);
            border-top-left-radius: pxTorem(15px);
            border-top-right-radius: pxTorem(15px);
          }
          .new {
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;
            width: pxTorem(66px);
          }
          .coverBox {
            width: pxTorem(220px);
            height: pxTorem(113px);
            overflow: hidden;
            .cover {
              width: pxTorem(220px);
              border-top-left-radius: pxTorem(15px);
              border-top-right-radius: pxTorem(15px);
            }
          }
        }
        .comicTitle {
          color: #000;
          position: absolute;
          font-family: "Noto Sans JP", sans-serif;
          font-weight: 400;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          font-size: pxTorem(20px);
          line-height: pxTorem(30px);
        }
      }
    }
    .navBox {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: pxTorem(40px) 0 pxTorem(50px);
      font-family: "Noto Sans JP", sans-serif;
      font-weight: 400;
      .navButton {
        background-color: #49b5e6;
        color: #fff;
        font-size: pxTorem(20px);
        line-height: pxTorem(20px);
        margin: 0 pxTorem(7px);
        cursor: pointer;
        padding: pxTorem(6px) pxTorem(19px) pxTorem(10px);
        border-radius: pxTorem(5px);
        font-weight: bold;
      }
      .comicNum {
        background-color: #49b5e6;
        color: #fff;
        font-size: pxTorem(20px);
        line-height: pxTorem(20px);
        margin: 0 pxTorem(7px);
        cursor: pointer;
        padding: pxTorem(6px) pxTorem(55px) pxTorem(10px);
        border-radius: pxTorem(5px);
        white-space: nowrap;
        &.active {
          background-color: #fff;
          color: #49b5e6;
        }
      }
    }
  }
  .popup {
    width: 100%;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 9999;
    background-color: rgb(0, 0, 0, 0.43);
    overflow: auto;
    .popup_center {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      width: pxTorem(600px);
      height: pxTorem(900px);
      background-color: #fff;
      border-radius: pxTorem(12px);
      margin-top: pxTorem(30px);
      display: flex;
      flex-direction: column;
      align-items: center;
      .close {
        align-self: flex-end;
        width: pxTorem(40px);
        margin-top: pxTorem(20px);
        margin-right: pxTorem(22px);
        cursor: pointer;
      }
      .mainImg {
        margin-top: pxTorem(20px);
        width: pxTorem(500px);
      }
      .popup_navBox {
        display: flex;
        align-items: center;
        font-family: "Noto Sans JP", sans-serif;
        font-weight: 400;
        position: absolute;
        bottom: pxTorem(40px);
        .popup_navBox-navButton {
          background-color: #49b5e6;
          color: #fff;
          font-size: pxTorem(20px);
          line-height: pxTorem(20px);
          cursor: pointer;
          padding: pxTorem(6px) pxTorem(19px) pxTorem(10px);
          border-radius: pxTorem(3px);
          font-weight: bold;
        }
        .popup_comicNum {
          background-color: #49b5e6;
          color: #fff;
          font-size: pxTorem(20px);
          line-height: pxTorem(20px);
          margin: 0 pxTorem(10px);
          cursor: initial;
          padding: pxTorem(6px) pxTorem(55px) pxTorem(10px);
          border-radius: pxTorem(3px);
        }
      }
    }
  }
}
@media screen and (max-width: 600px) {
  .comics {
    width: 100%;
    background: url('../assets/images/comics/bg.png') no-repeat;
    background-size: cover;
    background-position: 74%;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    .title {
      margin-top: MpxTorem(250px);
      color: #fff;
      font-family: "Noto Sans JP", sans-serif;
      font-weight: 400;
      font-size: MpxTorem(50px);
      line-height: MpxTorem(50px);
      text-align: center;
      letter-spacing: MpxTorem(4px);
      .subtitle {
        font-size: MpxTorem(24px);
      }
    }
    .center {
      margin-top: MpxTorem(380px);
      position: relative;
      width: MpxTorem(1070px);
      height: 20%;
      border: initial;
      border-radius: MpxTorem(20px);
      background-color: initial;
      margin-bottom: MpxTorem(150px);
      .titleQImg {
        position: absolute;
        width: 96%;
        top: 0;
        right: 48%;
        transform: translate(50%, -100%);
      }
      .titleImg {
        position: absolute;
        width: 58.5%;
        top: 0;
        left: 52%;
        transform: translate(-50%, -100%);
      }
      .content {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        margin-top: initial;
        height: MpxTorem(1200px);
        .comic {
          width: MpxTorem(310px);
          height: MpxTorem(205px);
          margin: MpxTorem(0px) MpxTorem(15px) MpxTorem(60px);
          border: MpxTorem(3px) solid #fff;
          border-radius: MpxTorem(15px);
          overflow: hidden;
          background-color: #fff;
          position: relative;
          cursor: pointer;
          .imgBox {
            position: relative;
            .shadow {
              position: absolute;
              top: 0;
              left: 0;
              z-index: 1;
              width: MpxTorem(310px);
              height: MpxTorem(160px);
              background-color: rgb(0, 0, 0, 0.43);
              border-top-left-radius: MpxTorem(15px);
              border-top-right-radius: MpxTorem(15px);
            }
            .new {
              position: absolute;
              top: 0;
              left: 0;
              z-index: 1;
              width: MpxTorem(66px);
            }
            .coverBox {
              width: MpxTorem(310px);
              height: MpxTorem(160px);
              overflow: hidden;
              .cover {
                width: MpxTorem(310px);
                border-top-left-radius: MpxTorem(15px);
                border-top-right-radius: MpxTorem(15px);
              }
            }
          }
          .comicTitle {
            color: #000;
            position: absolute;
            font-family: "Noto Sans JP", sans-serif;
            font-weight: 400;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            font-size: MpxTorem(28px);
            line-height: MpxTorem(38px);
          }
        }
      }
      .navBox {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: MpxTorem(50px) 0 MpxTorem(100px);
        font-family: "Noto Sans JP", sans-serif;
        font-weight: 400;
        .navButton {
          background-color: #49b5e6;
          color: #fff;
          text-align: center;
          width: MpxTorem(40px);
          font-size: MpxTorem(35px);
          line-height: MpxTorem(35px);
          margin: 0 MpxTorem(7px);
          cursor: pointer;
          padding: MpxTorem(10px) MpxTorem(19px) MpxTorem(10px);
          border-radius: MpxTorem(5px);
          font-weight: bold;
        }
        .comicNum {
          background-color: #49b5e6;
          color: #fff;
          font-size: MpxTorem(35px);
          line-height: MpxTorem(35px);
          margin: 0 MpxTorem(7px);
          cursor: pointer;
          padding: MpxTorem(10px) MpxTorem(55px) MpxTorem(10px);
          border-radius: MpxTorem(5px);
          white-space: nowrap;
          &.active {
            background-color: #fff;
            color: #49b5e6;
          }
        }
      }
    }
    .popup {
      width: 100%;
      height: 100vh;
      position: fixed;
      left: 0;
      top: 0;
      z-index: 9999;
      background-color: rgb(0, 0, 0, 0.43);
      overflow: auto;
      .popup_center {
        position: absolute;
        top: 45%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: MpxTorem(800px);
        height: MpxTorem(1350px);
        background-color: #fff;
        border-radius: MpxTorem(12px);
        display: flex;
        flex-direction: column;
        align-items: center;
        .close {
          align-self: flex-end;
          width: MpxTorem(70px);
          margin-top: MpxTorem(20px);
          margin-right: MpxTorem(22px);
          cursor: pointer;
        }
        .mainImg {
          margin-top: MpxTorem(20px);
          width: MpxTorem(800px);
        }
        .popup_navBox {
          display: flex;
          align-items: center;
          font-family: "Noto Sans JP", sans-serif;
          font-weight: 400;
          position: absolute;
          bottom: MpxTorem(40px);
          .popup_navBox-navButton {
            background-color: #49b5e6;
            color: #fff;
            font-size: MpxTorem(40px);
            line-height: MpxTorem(40px);
            cursor: pointer;
            padding: MpxTorem(10px) MpxTorem(25px) MpxTorem(10px);
            border-radius: MpxTorem(6px);
            font-weight: bold;
          }
          .popup_comicNum {
            background-color: #49b5e6;
            color: #fff;
            font-size: MpxTorem(40px);
            line-height: MpxTorem(40px);
            margin: 0 MpxTorem(10px);
            cursor: pointer;
            padding: MpxTorem(10px) MpxTorem(95px) MpxTorem(10px);
            border-radius: MpxTorem(6px);
          }
        }
      }
    }
  }
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 1) {
  .comics {
    .center {
      .navBox {
        .comicNum {
          padding: pxTorem(10px) pxTorem(55px) pxTorem(10px);
        }
        .navButton {
          padding: pxTorem(10px) pxTorem(19px) pxTorem(10px);
        }
      }
    }
    .popup {
      .popup_center {
        .popup_navBox {
          .popup_navBox-navButton {
            padding: pxTorem(10px) pxTorem(19px) pxTorem(10px);
          }
          .popup_comicNum {
            padding: pxTorem(10px) pxTorem(55px) pxTorem(10px);
          }
        }
      }
    }
  }
}
</style>